// ---------------------------------------------------------
// Datei: ticketSort.ts
// Zweck: Gemeinsame Sortierung von Nacharbeiten-/Wartungstickets nach Aktualität
// Kontext: loadNacharbeitenForDeal/loadWartungForDeal in HubSpotDealsPage.tsx
//          nutzten dieselbe Inline-Sortierlogik zweimal; hier extrahiert, damit
//          das Datum-Parsing (inkl. NaN-Fallback bei fehlenden Zeitstempeln) an
//          einer Stelle getestet werden kann.
// Stand: 24. August 2026
// ---------------------------------------------------------

export interface RecencyTimestamped {
  createdAt: string | null;
  lastModifiedAt: string | null;
}

export function sortTicketsByRecency<T extends RecencyTimestamped>(tickets: T[]): T[] {
  return tickets.slice().sort((left, right) => {
    const leftTs = Date.parse(left.lastModifiedAt || left.createdAt || '') || 0;
    const rightTs = Date.parse(right.lastModifiedAt || right.createdAt || '') || 0;
    return rightTs - leftTs;
  });
}
